import { call, put } from "redux-saga/effects";
import axios from "../../config/AxiosConfig";
import {
  addAccountVerificationDocumentFail,
  addAccountVerificationDocumentStart,
  deleteAccountVerificationDocumentFail,
  editAccountVerificationUserFail,
  editAccountVerificationUserStart,
  editAccountVerificationUserSuccess,
  getAccountVerificationDocumentsFail,
  getAccountVerificationDocumentsStart,
  getAccountVerificationDocumentsSuccess,
  getAccountVerificationUserFail,
  getAccountVerificationUsersFail,
  getAccountVerificationUsersStart,
  getAccountVerificationUsersSuccess,
  getAccountVerificationUserStart,
  getAccountVerificationUserSuccess,
} from "../actions/index";
import {
  ACCOUNT_VERIFICATION_DOCUMENTS,
  ACCOUNT_VERIFICATION_USERS,
} from "../actions/apiCollections";

export function* getAccountVerificationUsersSaga(action) {
  yield put(getAccountVerificationUsersStart());
  try {
    const response = yield axios.get(ACCOUNT_VERIFICATION_USERS, {
      params: {
        ...(action.search !== undefined && {
          search: action.search.search,
          status: action.search.status,
        }),

        limit: 10 * action.pageLimit,
      },
    });

    yield put(getAccountVerificationUsersSuccess(response.data.data.data));
  } catch (error) {
    yield put(getAccountVerificationUsersFail(error.response.data));
  }
}

export function* getAccountVerificationUserSaga(action) {
  yield put(getAccountVerificationUserStart());
  try {
    const response = yield axios.get(
      `${ACCOUNT_VERIFICATION_USERS}/${action.id}`
    );

    yield put(getAccountVerificationUserSuccess(response.data.data.data));
  } catch (error) {
    yield put(getAccountVerificationUserFail(error.response.data));
  }
}

export function* editAccountVerificationUser(action) {
  yield put(editAccountVerificationUserStart());
  try {
    const response = yield axios.patch(
      `${ACCOUNT_VERIFICATION_USERS}/${action.id}`,
      action.formData
    ); // API call

    yield put(editAccountVerificationUserSuccess(response.data.data.data));
  } catch (error) {
    yield put(editAccountVerificationUserFail(error.response.data));
  }
}

export function* getAccountVerificationDocumentsSaga(action) {
  yield put(getAccountVerificationDocumentsStart());
  try {
    const response = yield axios.get(
      `${ACCOUNT_VERIFICATION_DOCUMENTS}/${action.id}`
    );

    yield put(getAccountVerificationDocumentsSuccess(response.data.data.data));
  } catch (error) {
    yield put(getAccountVerificationDocumentsFail(error.response.data));
  }
}

export function* addAccountVerificationDocumentSaga(action) {
  yield put(addAccountVerificationDocumentStart());
  try {
    yield axios.post(
      `${ACCOUNT_VERIFICATION_DOCUMENTS}/${action.id}`,
      action.formData
    );
    yield call(getAccountVerificationDocumentsSaga, action);
  } catch (error) {
    yield put(addAccountVerificationDocumentFail(error.response.data));
  }
}

export function* deleteAccountVerificationDocumentSaga(action) {
  try {
    yield axios.delete(`${ACCOUNT_VERIFICATION_DOCUMENTS}/${action.documentId}/${action.id}`);
    yield call(getAccountVerificationDocumentsSaga, action);
  } catch (error) {
    yield put(deleteAccountVerificationDocumentFail(error.response));
  }
}
